export interface PartnerContacts {
  instagram?: string;
  phone?: string;
  website?: string;
  address?: string;
}

export interface Partner {
  id: string;
  name: string;
  category: string;
  type: "B2C" | "B2B";
  benefitLabel: string;
  benefitShort: string;
  offer: string;
  details: string;
  contacts: PartnerContacts;
  image: string;
}

// Порядок: самые привлекательные и узнаваемые партнёры — наверху.
export const partners: Partner[] = [
  {
    id: "recvLLIPZXr0vgvcA",
    name: "EL VIENTO",
    category: "Женская одежда",
    type: "B2C",
    benefitLabel: "Сертификат",
    benefitShort: "30 BYN",
    offer: "Сертификат на 30 BYN на первую покупку",
    details: "Женская одежда с лаконичными силуэтами и тёплой палитрой. Сертификат получают все ученицы AMANI при покупке любого пакета занятий.",
    contacts: { instagram: "elviento.brand" },
    image: "/partners/elviento.jpg",
  },
  {
    id: "recUZwjJUIy1eg0rC",
    name: "Планета СПА",
    category: "СПА-комплекс",
    type: "B2B",
    benefitLabel: "Скидка",
    benefitShort: "50%",
    offer: "50% на термальный комплекс и скидки на все СПА-программы",
    details: "Хаммам, джакузи и финская сауна — открытое посещение 1,5 часа, минимум 2 человека.",
    contacts: { phone: "+375447177575", instagram: "planeta_spa_in_minsk", address: "ул. Чкалова, 9/2" },
    image: "/partners/planeta-spa.png",
  },
  {
    id: "recDpduZsrJKr41PH",
    name: "GLADKO",
    category: "Красота",
    type: "B2C",
    benefitLabel: "Сертификат",
    benefitShort: "20 BYN",
    offer: "Сертификат на 20 BYN на первое посещение коррекции фигуры",
    details: "Сеть студий красоты. Депиляция (воск и шугаринг), косметология (пилинги, чистки, массажи лица), коррекция фигуры, брови и ресницы.",
    contacts: { instagram: "gladko_by" },
    image: "/partners/gladko.jpg",
  },
  {
    id: "recWZ5ZUIYCqqftDP",
    name: "Holiday Club",
    category: "Путешествия",
    type: "B2C",
    benefitLabel: "Скидка",
    benefitShort: "7%",
    offer: "7% на первое обращение по авиатурам с вылетом из Минска",
    details: "Туристическое агентство — организация отдыха под ключ.",
    contacts: { website: "holidayclub.by", instagram: "holidayclubby", address: "ул. Веры Хоружей, 3, офис 117" },
    image: "/partners/holiday-club.jpg",
  },
  {
    id: "recQQAGSPXnPNYiM6",
    name: "BELKA NAILS",
    category: "Маникюр",
    type: "B2C",
    benefitLabel: "Скидка",
    benefitShort: "10%",
    offer: "Постоянная скидка 10% на все услуги",
    details: "Маникюр и педикюр. Более 1000 оттенков, система IBX для укрепления, гарантия 5 дней, бесплатная парковка.",
    contacts: { phone: "+375293182062", instagram: "nail_gel_minsk_by", address: "ул. Налибокская, 21" },
    image: "/partners/belka-nails.png",
  },
  {
    id: "recqdXzEA34Ru3L80",
    name: "PIATKI",
    category: "Подология",
    type: "B2C",
    benefitLabel: "Скидка",
    benefitShort: "10%",
    offer: "Постоянная скидка 10% на все услуги",
    details: "Студии подологии и ортопедии — уход за стопами и ногтями, ортопедические стельки.",
    contacts: { phone: "+375336383687", website: "piatki.by", instagram: "piatki_minssk" },
    image: "/partners/piatki.png",
  },
  {
    id: "recGPtlt4Y39sM1gW",
    name: "ZAGAR",
    category: "Студии загара",
    type: "B2C",
    benefitLabel: "Скидка",
    benefitShort: "10%",
    offer: "Скидка 10% на первое посещение",
    details: "Сеть студий моментального загара.",
    contacts: { phone: "+375333016145", instagram: "zagar_", address: "ул. Притыцкого, 34 · ул. Петра Мстиславца, 24" },
    image: "/partners/zagar.png",
  },
  {
    id: "recLB4ZT6s9BzeJ9w",
    name: "Sferatube",
    category: "Аппаратный массаж",
    type: "B2B",
    benefitLabel: "Скидка",
    benefitShort: "30%",
    offer: "30% на первое посещение и 20% на абонемент",
    details: "10 функций в одном аппарате: лимфодренаж, антицеллюлит, пилинг, лифтинг, похудение, снятие отёков и зажимов.",
    contacts: { phone: "+375336340800", instagram: "royal_massage.by", address: "ул. Николы Теслы, 21 (Минск-Мир)" },
    image: "/partners/apparatny-massage.png",
  },
  {
    id: "recusARKe1L9pv5TR",
    name: "Head massage Minsk",
    category: "АСМР-массаж",
    type: "B2C",
    benefitLabel: "Скидка",
    benefitShort: "10 BYN",
    offer: "Скидка 10 BYN на все ASMR-комплексы",
    details: "Первая студия АСМР-массажа в Минске. Расслабляющий сеанс для нервной системы — мурашки, шорохи и полное переключение с мыслей на тело.",
    contacts: { phone: "+375445680979", instagram: "head_massage_minsk" },
    image: "/partners/head-massage.png",
  },
  {
    id: "reccQEnnl96WxRi3k",
    name: "PollyJewelry",
    category: "Украшения для танца",
    type: "B2C",
    benefitLabel: "Скидка",
    benefitShort: "10%",
    offer: "10% на все украшения для учениц AMANI",
    details: "Украшения из страз для восточных танцев, сцены и праздников. В наличии и под заказ.",
    contacts: { instagram: "polina_bellydance_jewelry_" },
    image: "/partners/polly-jewelry.jpg",
  },
  {
    id: "recThxcGSlf0ygRqL",
    name: "LYNX",
    category: "Одежда для тренировок",
    type: "B2B",
    benefitLabel: "Скидка",
    benefitShort: "15%",
    offer: "Постоянная скидка 15% на весь ассортимент",
    details: "Белорусский бренд тренировочной одежды. Оригинальный дизайн, состав: 80% полиамид, 10% эластан, 10% lycra-sport.",
    contacts: { instagram: "lynx.by" },
    image: "/partners/lynx.png",
  },
  {
    id: "recq26nsXVfnQmOOZ",
    name: "WOWLOTO",
    category: "Музыкальное лото",
    type: "B2C",
    benefitLabel: "",
    benefitShort: "",
    offer: "Привилегии для учениц AMANI",
    details: "Живое музыкальное лото с хитами разных эпох — для корпоративов и вечеринок.",
    contacts: { instagram: "wowloto_minsk" },
    image: "/partners/wowloto.jpg",
  },
];
